import React, { useMemo } from 'react';
import styled from 'styled-components';
import ImgFit from '../atoms/ImgFit';
import { clickById } from '../../api/Shortcuts';
import { readFile } from '../../utils/loadImg';

const Border = styled.label`
  border: 2px dashed darkgray; // TODO: receber por parâmetro
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Placeholder = styled.div`
  text-align: center;
  color: darkgray;
`;

const HiddenInput = styled.input`
  display: none;
`;

export default function ImgUploadBtn({
  className,
  flavorTxt,
  id,
  src = '',
  onClick,
  onChange,
  style,
  storage,
  borderRadius,
  ...props
}) {
  const placeholderId = `${id}_placeholder`;
  const imgId = `${id}_img`;
  const inputId = `${id}_input`;
  const borderStyle = borderRadius ? { style, borderRadius } : style;

  const imgURL = useMemo(() => {
    if (!src) return;
    if (Array.isArray(src)) return src[1];
    return src;
  }, [src]);

  return (
    <>
      <Border id={id} className={className} onClick={() => clickById(inputId)} style={borderStyle}>
        <Placeholder id={placeholderId} style={{ display: imgURL ? 'none' : 'inline' }}>
          <i className="fas fa-camera" />
          {flavorTxt ? <p>{flavorTxt}</p> : null}
        </Placeholder>
        <ImgFit id={imgId} src={imgURL} style={{ display: imgURL ? 'inline' : 'none' }} />
      </Border>
      <HiddenInput
        type="file"
        id={inputId}
        onChange={async (event) => {
          const file = event.target.files[0];
          const { dataURL } = await readFile(file);
          onChange([file, dataURL]);
        }}
      />
    </>
  );
}
